import React from "react";
import ClientList from "./ClientList";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";

interface Props {
  selectedClients: server.dto.ClientSmall[]
  onChange: (newClients: server.dto.ClientSmall[]) => void
}

const ClientMultiPicker = (props: Props) => {
  return <MultiPickerSelectedItems
    selectedItems={props.selectedClients}
    onRemove={props.onChange}
    getId={client => client.clientId}
    getLabel={client => <div>
      {client.name}
    </div>}
  >
    <ClientList
      preferredClients={[]}
      onItemSelected={(item) => props.onChange([...props.selectedClients, item])}
      excludeKeys={props.selectedClients.map(ff => ff.clientId)}
    />
  </MultiPickerSelectedItems>;
};

export default ClientMultiPicker;